export default "__VITE_ASSET__3d893121__"